<section id="posturas">
  <h6 class="position-title">Posturas de mercado</h6>
  <div class="titles">
    <div class="left">Compra</div>
    <div class="right">Venta</div>
  </div>
  <div class="single">
    <ul class="title">
      <div class="compra">
        <li class="vol-compra">Volumen</li>
        <li class="prc-compra">Precio</li>
      </div>
      <div class="venta">
        <li class="prc-venta">Precio</li>
        <li class="vol-venta">Volumen</li>
      </div>
    </ul>

    <ul *ngIf="hasIssue">
      <div class="compra" (click)="setPrice(single.ask)">
        <li class="vol-compra">
          {{ single?.askSize | hbCustomFormat: '0,0' }}
        </li>
        <li class="precio prc-compra">
          {{
            single?.ask
              | hbCustomFormat: (single?.ask < 1 ? '$0,0.000' : '$0,0.00')
          }}
        </li>
      </div>
      <div class="venta" (click)="setPrice(single.bid)">
        <li class="precio prc-venta">
          {{
            single?.bid
              | hbCustomFormat: (single?.bid < 1 ? '$0,0.000' : '$0,0.00')
          }}
        </li>
        <li class="vol-venta">{{ single?.bidSize | hbCustomFormat: '0,0' }}</li>
      </div>
    </ul>

    <ul *ngIf="!hasIssue">
      <div class="compra closed">
        <li class="vol-compra">--</li>
        <li class="prc-compra">--</li>
      </div>
      <div class="venta closed">
        <li class="prc-venta">--</li>
        <li class="vol-venta">--</li>
      </div>
    </ul>
  </div>
  <div
    class="deep"
    [class.opened]="opened"
    *ngIf="hasLevel && hasIssue && !NO_LEVEL2"
  >
    <div class="deep-container">
      <div class="data">
        <ul *ngFor="let postura of posturasList; let i = index">
          <div *ngIf="i === 1 || i === 3">
            <div class="compra" (click)="setPrice(postura.ask)">
              <li class="vol-compra">
                {{ postura.askSize | hbCustomFormat: '0,0' }}
              </li>
              <li class="precio">
                {{
                  postura.ask
                    | hbCustomFormat: (postura.ask < 1 ? '$0,0.000' : '$0,0.00')
                }}
              </li>
            </div>
            <div class="venta" (click)="setPrice(postura.bid)">
              <li class="precio prc-venta">
                {{
                  postura.bid
                    | hbCustomFormat: (postura.bid < 1 ? '$0,0.000' : '$0,0.00')
                }}
              </li>
              <li class="vol-venta">
                {{ postura.bidSize | hbCustomFormat: '0,0' }}
              </li>
            </div>
          </div>

          <div *ngIf="i === 0 || i === 2">
            <div class="compra-white" (click)="setPrice(postura.ask)">
              <li class="vol-compra">
                {{ postura.askSize | hbCustomFormat: '0,0' }}
              </li>
              <li class="precio">
                {{
                  postura.ask
                    | hbCustomFormat: (postura.ask < 1 ? '$0,0.000' : '$0,0.00')
                }}
              </li>
            </div>
            <div class="venta-white" (click)="setPrice(postura.bid)">
              <li class="precio prc-venta">
                {{
                  postura.bid
                    | hbCustomFormat: (postura.bid < 1 ? '$0,0.000' : '$0,0.00')
                }}
              </li>
              <li class="vol-venta">
                {{ postura.bidSize | hbCustomFormat: '0,0' }}
              </li>
            </div>
          </div>
        </ul>
      </div>
      <div class="header" (click)="toggleDeep()" *ngIf="hasIssue">
        <div>
          <div class="deep-title" *ngIf="!opened">Mostrar profundidad</div>
          <div class="deep-title" *ngIf="opened">
            Ocultar profundidad
            <div class="icon-flecha-arriba"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
